import { render, staticRenderFns } from "./LotDetailOutList.vue?vue&type=template&id=06bb01d3&scoped=true"
import script from "./LotDetailOutList.vue?vue&type=script&lang=js"
export * from "./LotDetailOutList.vue?vue&type=script&lang=js"
import style0 from "./LotDetailOutList.vue?vue&type=style&index=0&id=06bb01d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb01d3",
  null
  
)

export default component.exports